// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-image-full-item/banner-hero-image-full-item.component.scss
// module id = 135
// module chunks = 0